<template>
    <div class="row">
        <div class="col-sm-12">
            <h3>{{$t('components.administration.news.btnCreate')}}</h3>
            <router-link :to="{name: 'app.admin.news'}" class="btn btn-sm btn-wos-real mt-3 mb-4">
                {{$t('components.administration.news.btnBackNews')}}
            </router-link>
            <hr>
            <div class="row">
                <div class="col-sm-12">
                    <form @submit="handleFormSubmit">
                        <div class="row">
                            <div class="col-sm-12 col-md-3">
                                <label>{{$t(compItem.objstate.label)}}</label>
                                <select class="form-control form-control-sm custom-select" v-model="item.objstate.value">
                                    <option value="INACTIVE">{{$t('inactive') | capitalize}}</option>
                                    <option value="ACTIVE">{{$t('active') | capitalize}}</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-3">
                                <label>{{$t(compItem.category_id.label)}}</label>
                                <select class="form-control form-control-sm custom-select" v-model="item.category_id.value">
                                    <option :value="category.id" v-for="category in categories" :key="category.id">
                                        {{category.name}}
                                    </option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-3">
                                <label>{{$t(compItem.special.label)}}</label>
                                <select class="form-control form-control-sm custom-select" v-model="item.special.value">
                                    <option :value="false">{{$t('confirm.no')}}</option>
                                    <option :value="true">{{$t('confirm.yes')}}</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-3">
                                <label>{{$t(compItem.available_at.label)}}</label>
                                <input class="form-control form-control-sm" v-model="item.available_at.value"
                                       placeholder="YYYY-MM-DD HH:II:SS"/>
                            </div>
                        </div>
                        <div class="row mt-3 mb-3">
                            <div class="col-sm-12 col-md">
                                <label>{{$t(compItem.hierarchies.label)}}</label>
                                <MultiSelect v-model="item.hierarchies.value" :options="hierarchies"
                                             :placeholder="$t('please-select')"
                                             :multiple="true"
                                             :close-on-select="false"
                                             :clear-on-select="true"
                                             :preserve-search="true"
                                             label="description" track-by="description">
                                </MultiSelect>
                            </div>
                        </div>
                        <div class="row mt-3 mb-5">
                            <div class="col-sm-12">
                                <b-dropdown :disabled="availableLocales.length === 0">
                                    <template v-slot:button-content>
                                        <i class="fa fa-plus"></i> {{$t('components.administration.news.btnAddLocalization')}}
                                    </template>
                                    <b-dropdown-item v-for="locale in availableLocales" :key="locale"
                                                     @click="addLocalization(locale)">
                                        {{locale | toUpper}}
                                    </b-dropdown-item>
                                </b-dropdown>

                            </div>
                        </div>
                        <hr>
                        <div class="card" v-for="locale in selectedLocales" :key="locale">
                            <div class="card-header">
                                <h3 class="card-title d-inline">{{locale | toUpper}}</h3>
                                <button type="button"
                                        class="float-right d-inline btn btn-sm btn-outline-wellis-black"
                                        @click="removeLocalization(locale)">
                                    <i class="fa fa-trash"></i>
                                </button>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-sm-12 col-md-6">
                                        <div class="form-group">
                                            <label>{{$t(localization[locale].header_image_url.label)}}</label>
                                            <input class="form-control form-control-sm" type="text"
                                                   v-model="item.localization[locale].header_image_url.value"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12 col-md-6">
                                        <div class="form-group">
                                            <label>{{$t(localization[locale].title.label)}}</label>
                                            <input class="form-control form-control-sm" type="text"
                                                   :maxlength="item.localization[locale].title.maxLength"
                                                   v-model="item.localization[locale].title.value"/>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 col-md-6">
                                        <div class="form-group">
                                            <label>{{$t(localization[locale].lead.label)}}</label>
                                            <textarea class="form-control form-control-sm" rows="3"
                                                      :maxlength="item.localization[locale].lead.maxLength"
                                                      v-model="item.localization[locale].lead.value"></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="form-group">
                                            <label>{{$t(item.localization[locale].content.label)}}</label>
                                            <TextEditor class="border" :content="item.localization[locale].content.value"
                                                        v-on:updateContent="content => item.localization[locale].content.value = content"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 text-center">
                                <button class="w-25 btn btn-wellis-gold text-white">
                                    <i class="fa fa-save"></i>
                                    {{$t('btnSave') | toUpper}}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CategoryApiService from "@/api/category.api";
import TextEditor from "@/components/common/TextEditor";
import {empty} from "@/helpers";
import NewsApiService from "@/api/news.api";
import MultiSelect from 'vue-multiselect';

export default {
    name: "NewsEditor",
    components: {TextEditor, MultiSelect},
    data() {
        return {
            edit: false,
            postId: null,
            categories: [],
            locales: [],
            hierarchies: [],
            selectedLocales: [],
            item: {
                objstate: {
                    label: 'components.administration.category.status',
                    value: 'ACTIVE',
                    required: true
                },

                category_id: {
                    label: 'components.administration.news.category',
                    value: null,
                    required: true
                },

                available_at: {
                    label: 'components.administration.news.availableAt',
                    value: null,
                    required: false,
                },

                special: {
                    label: 'components.administration.news.special',
                    value: false,
                    required: true
                },

                hierarchies: {
                    label: 'components.administration.category.news.hierarchies',
                    value: [],
                    required: false
                },

                localization: {}
            }
        }
    },

    created() {

        if (this.$route.name === 'app.admin.news.edit') {
            this.edit = true;
        }

        this.getCategories()
            .then(() => {
                if (this.edit) {
                    NewsApiService.concrete(null, this.$route.params.id)
                        .then(response => {
                            this.postId = response.data.id;
                            this.item.objstate.value = response.data.objstate;
                            this.item.category_id.value = response.data.category_id;
                            this.item.available_at.value = response.data.available_at;
                            const attributes = JSON.parse(response.data.attributes);
                            this.item.special.value = attributes.special;
                            if (attributes.hierarchy_lock.length > 0) {
                                attributes.hierarchy_lock.forEach(item => {
                                    const hierarchy = this.hierarchies.find(x => x.hierarchy_id === item);
                                    if (hierarchy) {
                                        this.item.hierarchies.value.push(hierarchy);
                                    }
                                });
                            }

                            response.data.localizations.forEach(item => {
                                this.addLocalization(item.lang, item);
                            });
                        });
                } else {
                    this.addLocalization(this.$store.getters['langStore/current']);
                }
            });
    },

    methods: {
        getCategories() {
            return new Promise((resolve, reject) => {
                let loader = this.$loading.show();
                CategoryApiService.getNews({is_administration: true})
                    .then(response => {
                        this.$set(this, 'categories', response.data.categories);
                        this.$set(this, 'hierarchies', response.data.hierarchies);
                        this.$set(this, 'locales', response.data.locales);
                        resolve(response.data);
                    })
                    .catch(e => reject(e))
                    .finally(() => {
                        loader.hide();
                        loader = null;
                    });
            });
        },

        addLocalization(locale, data = null) {
            this.item.localization[locale] = {
                locale: locale,
                header_image_url: {
                    label: 'components.administration.news.image',
                    value: data ? data.header_image_url : null,
                    required: true
                },
                title: {
                    label: 'components.administration.news.title',
                    value: data ? data.title : null,
                    required: true,
                    maxLength: 150,
                },
                lead: {
                    label: 'components.administration.news.lead',
                    value: data ? data.lead : null,
                    required: false,
                    maxLength: 500
                },
                content: {
                    label: 'components.administration.news.content',
                    value: data ? data.content : null,
                    required: false,
                },
            };
            this.selectedLocales.push(locale);
        },

        removeLocalization(locale) {
            this.selectedLocales.splice(this.selectedLocales.indexOf(locale), 1);
            delete this.localization[locale];
        },

        validateForm() {
            return new Promise((resolve, reject) => {
                let errors = [];
                Object.keys(this.item).forEach(key => {
                    if (key !== 'localization') {
                        if (this.item[key].required && empty(this.item[key].value)) {
                            errors.push(this.$t('validation.required', {field: this.$t(this.item[key].label)}));
                        }
                    } else {
                        Object.values(this.item[key]).forEach(item => {
                            Object.keys(item).forEach(subKey => {
                                if (subKey !== 'locale') {
                                    if (item[subKey].required && empty(item[subKey].value)) {
                                        errors.push("[" + item['locale'].toUpperCase() + "] " + this.$t('validation.required', {
                                            field: this.$t(item[subKey].label)
                                        }));
                                    }
                                }
                            });
                        });
                    }
                });


                if (errors.length > 0) {
                    return reject(errors);
                } else {
                    const formData = {
                        objstate: this.item.objstate.value,
                        category: this.item.category_id.value,
                        available_at: this.item.available_at.value,
                        attributes: {
                            special: this.item.special.value,
                            hierarchy_lock: this.item.hierarchies.value.map(item => item.hierarchy_id),
                        },
                        localizations: []
                    };

                    Object.values(this.item.localization).forEach(item => {
                        formData.localizations.push({
                            lang: item.locale,
                            header_image_url: item.header_image_url.value,
                            title: item.title.value,
                            lead: item.lead.value,
                            content: item.content.value,
                        })
                    });
                    return resolve(formData);
                }
            });
        },

        handleFormSubmit(e) {
            e.preventDefault();
            this.validateForm()
                .then(formData => {
                    if (this.edit) {
                        NewsApiService.update(this.postId, formData)
                            .then(() => {
                                this.$swal.fire({
                                    icon: "success",
                                    allowOutsideClick: false,
                                    html: this.$t('components.administration.news.update-success')
                                });
                            })
                            .catch(() => {
                                this.$swal.fire({
                                    icon: "error",
                                    allowOutsideClick: false,
                                    html: this.$t('whoops')
                                });
                            });
                    } else {
                        NewsApiService.create(formData)
                            .then(() => {
                                this.$swal.fire({
                                    icon: "success",
                                    allowOutsideClick: false,
                                    html: this.$t('components.administration.news.create-success')
                                }).then(() => {
                                    this.$router.push({name: 'app.admin.news'})
                                });
                            })
                            .catch(() => {
                                this.$swal.fire({
                                    icon: "error",
                                    allowOutsideClick: false,
                                    html: this.$t('whoops')
                                });
                            });
                    }
                })
                .catch(errors => {
                    this.$swal.fire({
                        icon: "error",
                        allowOutsideClick: false,
                        html: errors.join('<br>')
                    });
                });

        }
    },

    computed: {

        compItem() {
            return this.item;
        },

        localization() {
            return this.item.localization;
        },

        availableLocales() {
            return this.locales.filter(locale => {
                return this.selectedLocales.indexOf(locale) === -1;
            });
        },
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.custom-select {
    height: 35px;
    padding: unset;
}
</style>
